import { useState, useEffect } from 'react';
import { useHistory, Link as ReactRouterLink } from 'react-router-dom';
import { useForm } from '../../hooks';

import { Typography, Grid, Link, FormControlLabel } from '@mui/material';

import { Button, TextField, Checkbox, Form } from '../common';
import { auth, emailValidator, tokenUtils } from '../../utils';
import colors from '../../assets/colors';

export default function LoginForm() {
  const { handleChange, values } = useForm({ email: '', password: '' });
  const [isLoginSuccessful, setIsLoginSuccessful] = useState(true);
  const [errorText, setErrorText] = useState('');
  const [isFormDataComplete, setIsFormDataComplete] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState({
    rememberMeCheckbox: false,
  });
  const history = useHistory();
  useEffect(() => {
    if (
      values.email.length > 0 &&
      values.password.length > 0 &&
      emailValidator(values.email)
    ) {
      setIsFormDataComplete(true);
    } else {
      setIsFormDataComplete(false);
    }
  }, [values.email, values.email.length, values.password.length]);

  const handleSubmit = (e) => {
    e.preventDefault();
    auth
      .login(values.email, values.password)
      .then((result) => {
        const isAdmin = tokenUtils.parseJwtAdmin(result.data.jwt);
        if (isAdmin) {
          tokenUtils.setToken(result);
          setIsLoginSuccessful(true);
          setErrorText('');
          history.push('/dashboard/permissions-management');
        }
      })
      .catch((err) => {});

    auth
      .loginBank(values.email, values.password)
      .then((result) => {
        tokenUtils.setToken(result);
        setIsLoginSuccessful(true);
        setErrorText('');
        if (!result.data.isPasswordChanged) history.push('/set-password');
        else history.push('/dashboard/multiple-clients');
      })
      .catch((err) => {
        setIsLoginSuccessful(false);
        if (err.response.data === 'User does not exist') {
          setErrorText('Użytkownik nie istnieje');
        } else if (err.response.data === 'Account not activated') {
          setErrorText(
            'Konto nie zostało aktywowane. Sprawdź swoją pocztę elektroniczną.'
          );
        } else if (err.response.data === 'Incorrect username or password') {
          setErrorText('Nieprawidłowy email lub hasło.');
        } else if (err.response.data === 'Password is incorrect!') {
          setErrorText('Nieprawidłowe hasło.');
        } else {
          setErrorText('');
        }
      });
  };

  const handleCheckboxChange = (event) => {
    setIsCheckboxChecked({
      ...isCheckboxChecked,
      [event.target.name]: event.target.checked,
    });
  };

  return (
    <>
      <Typography variant="h4" sx={{ mt: 10, fontWeight: 600 }}>
        Zaloguj się
      </Typography>
      <Form noValidate>
        <TextField
          login
          variant="outlined"
          margin="normal"
          required
          fullWidth
          label="ADRES E-MAIL"
          name="email"
          autoComplete="email"
          onChange={handleChange('email')}
          autoFocus
          error={values.email.length > 0 && !emailValidator(values.email)}
          helperText={
            values.email.length > 0 &&
            !emailValidator(values.email) &&
            'Nieprawidłowy adres email!'
          }
          sx={{ mt: 5 }}
          InputLabelProps={{ shrink: true }}
          inputProps={{ 'data-testid': 'email' }}
        />
        <TextField
          login
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="password"
          label="HASŁO"
          type="password"
          id="password"
          onChange={handleChange('password')}
          autoComplete="current-password"
          error={!isLoginSuccessful}
          helperText={
            !isLoginSuccessful ? [errorText] : 'POLA OZNACZONE * SĄ WYMAGANE'
          }
          sx={{ mt: 4 }}
          InputLabelProps={{ shrink: true }}
          inputProps={{ 'data-testid': 'password' }}
        />
        <FormControlLabel
          control={
            <Checkbox
              value="rememberMeCheckbox"
              onChange={handleCheckboxChange}
              checked={isCheckboxChecked.rememberMeCheckbox}
              name="rememberMeCheckbox"
            />
          }
          label="Zapamiętaj mnie"
          sx={{ mt: 1 }}
        />
        <Button
          login
          type="submit"
          fullWidth
          variant="outlined"
          disabled={!isFormDataComplete}
          onClick={handleSubmit}
          sx={{ mt: 5 }}
        >
          Zaloguj się
        </Button>
        <Grid container sx={{ mt: 3 }}>
          <Grid item xs>
            <Link
              component={ReactRouterLink}
              to="/forgot-password"
              variant="body2"
              sx={{ color: colors.oldAgroweGreen }}
            >
              Zapomniałeś hasła ?
            </Link>
          </Grid>
          {/* <Grid item>
            <Link
              component={ReactRouterLink}
              to="/register"
              variant="body2"
              sx={{ color: colors.oldAgroweGreen }}
            >
              {'Nie posiadasz jeszcze konta? Zarejestruj się!'}
            </Link>
          </Grid> */}
        </Grid>
      </Form>
    </>
  );
}
